import { useAlertContext } from "@shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useTranslation } from "@/translations";

import { MergeDialogItem } from "../MergeFilesDialog.types";

interface UseMergeFilesParams {
  mergeFn: (orderedItems: MergeDialogItem[]) => Promise<unknown>;
  invalidationKeys: unknown[][];
  onSuccess?: () => void;
}

export function useMergeFiles({ mergeFn, invalidationKeys, onSuccess }: UseMergeFilesParams) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showSuccess } = useAlertContext();

  return useMutation({
    mutationFn: mergeFn,
    onSuccess: () => {
      for (const key of invalidationKeys) {
        void queryClient.invalidateQueries({ queryKey: key });
      }
      showSuccess(t("dropzone.merge.success"));
      onSuccess?.();
    },
  });
}
